<template>
  <svg
    :height="styles.height"
    :viewBox="'0 0 13 13'"
    :width="styles.width"
  >
    <g transform="translate(-488.000000, -1216.000000)">
      <g transform="translate(488.000000, 1216.000000)">
        <circle :fill="styles.backgroundColor" cx="6.5" cy="6.5" r="6.5"></circle>
        <path d="M6.91088867,8.03564453 L6.9284668,7.76757812 C6.96069336,7.48046875 7.08813477,7.22998047 7.31079102,7.01611328 L7.31079102,7.01611328 L7.66674805,6.67773438 C7.94506836,6.40820312 8.13989258,6.1628418 8.2512207,5.94165039 C8.36254883,5.72045898 8.41821289,5.48535156 8.41821289,5.23632812 C8.41821289,4.68847656 8.24682617,4.2644043 7.90405273,3.96411133 C7.5612793,3.66381836 7.0793457,3.51367188 6.45825195,3.51367188 C5.84301758,3.51367188 5.35742188,3.671875 5.00146484,3.98828125 C4.64550781,4.3046875 4.46459961,4.74267578 4.45874023,5.30224609 L4.45874023,5.30224609 L5.7331543,5.30224609 C5.73901367,5.06787109 5.80712891,4.8840332 5.9375,4.75073242 C6.06787109,4.61743164 6.24145508,4.55078125 6.45825195,4.55078125 C6.9152832,4.55078125 7.14379883,4.79833984 7.14379883,5.29345703 C7.14379883,5.45751953 7.09985352,5.61352539 7.01196289,5.76147461 C6.92407227,5.90942383 6.74755859,6.10131836 6.48242188,6.3371582 C6.21728516,6.57299805 6.03491211,6.8125 5.93530273,7.05566406 C5.83569336,7.29882812 5.78588867,7.62548828 5.78588867,8.03564453 L5.78588867,8.03564453 L6.91088867,8.03564453 Z M6.37036133,10.0527344 C6.58422852,10.0527344 6.75634766,9.98974609 6.88671875,9.86376953 C7.01708984,9.73779297 7.08227539,9.578125 7.08227539,9.38476562 C7.08227539,9.18847656 7.015625,9.02661133 6.88232422,8.89916992 C6.74902344,8.77172852 6.57836914,8.70800781 6.37036133,8.70800781 C6.16235352,8.70800781 5.99169922,8.77172852 5.85839844,8.89916992 C5.72509766,9.02661133 5.65844727,9.18847656 5.65844727,9.38476562 C5.65844727,9.578125 5.72363281,9.73779297 5.85400391,9.86376953 C5.984375,9.98974609 6.15649414,10.0527344 6.37036133,10.0527344 Z" :fill="styles.color" fill-rule="nonzero"></path>
      </g>
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'SvgIconHelp',
    props: {
      backgroundColor: {
        default: '#393939',
        type: String
      },
      color: {
        default: '#ffffff',
        type: String
      },
      height: {
        default: '13px',
        type: String
      },
      width: {
        default: '13px',
        type: String
      }
    },
    computed: {
      styles: function () {
        return {
          backgroundColor: `${this.backgroundColor}`,
          color: `${this.color}`,
          height: `${this.height}`,
          width: `${this.width}`
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/js/svgs/SvgIconHelp.vue